<template>
  <div class="navbar" :style="{ background: urgencyShow ? 'red' : '#fff' }">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    <!--    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="dialogVisible = false"
        >确 定</el-button>
      </span>
    </el-dialog> -->

    <!-- <div>888</div> -->

    <div class="right-menu">
      <div class="userAvatarlingdang" @click="massageSkip">

        <!-- <img :src="massageImage" alt=""> -->
        <el-tooltip class="item" effect="dark" :content=" ids ?'区块链是否在线,当前为在线':'区块链是否在线,当前为离线'" placement="left-end">
          <!-- <el-button>左下</el-button> -->
          <svg-icon :icon-class="ids ? 'yishanglian' :'weishanglian' " />
        </el-tooltip>
      </div>
      <div class="userAvatarlingdang" @click="massageSkip">

        <img :src="massageImage" alt="">
      </div>
      <div class="userAvatar">
        <el-avatar class="avatarCss" icon="el-icon-user-solid" :size="40" :src="protoImg || logo">
          <!-- <img :src="circleUrl.img"> -->
        </el-avatar>
      </div>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div v-if="userName" class="avatar-wrapper">
          <i class="el-icon-caret-bottom" />
          <span class="user-avatar">{{ userName }}</span>
        </div>
        <div v-else class="avatar-wrapper">
          <i class="el-icon-caret-bottom" />
          <span class="user-avatar">{{
            userNames || usermassage? usermassage.userName :'123'
          }}</span>
        </div>

        <div />
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
          <!-- <div v-if="showNav"> -->
          <el-dropdown-item divided @click.native="section">
            <span style="display: block">修改信息 </span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="amendpass">
            <span style="display: block">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item v-if="['JJC'].indexOf(userRole) !== -1" divided @click.native="yuseh">
            <span style="display: block">预设坐标</span>
          </el-dropdown-item>

          <el-dropdown-item v-if="['03'].indexOf(userRole) !== -1" divided @click.native="childs">
            <span style="display: block">子账户</span>
          </el-dropdown-item>
          <!-- <el-dropdown-item divided @click.native="sections">
              <span style="display: block">设置</span>
            </el-dropdown-item> -->
          <!-- </div> -->
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
import {
  getToken
} from '@/utils/auth' // get token from cookie
import {
  chainThirdChainServerStatus
} from '@/api/blockchain.js'
  // import { cycleRequest } from "@/api/alarm.js"; // eslint-disable-line

// import { Base64 } from 'js-base64'
const base64 = require('js-base64').Base64
// import store from '../../store'
// import pubsub from 'pubsub-js' // 用来全局1传递参数
export default {
  components: {
    Breadcrumb,
    Hamburger,
      ErrorLog, // eslint-disable-line
      Screenfull, // eslint-disable-line
      SizeSelect, // eslint-disable-line
      Search // eslint-disable-line
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device',
      'urgencyShow',
      'protoImg',
      'userName',
      'usermassage'
    ])
  },
  data() {
    return {
      ids: false,
      massageImage: '',
      // userName:'',
      userNames: '',
      circleUrl: {
        img: '@/assets/Images/logo.png'
      }, // 用户头像
      logo: require('@/assets/Images/logo.png'),
      showNav: true,
      shows: false,
      imgShow: false,
      token: getToken(),
      // dialogVisible: false,
      LValue: false,
      LValueCole: false
    }
  },
  // computed: {

  // },
  created() {
    this.getqueryRemind()
    this.token = JSON.parse(base64.decode(this.token.split('.')[1]))
    this.userRole = this.token.userRole
    this.chainThirdChainServerStatus()
    if (this.userRole == 'ADMIN') {
        // eslint-disable-line
      this.showNav = true
    } else {
      this.showNav = false
    }
  },
  mounted() {
    this.circleUrl.img = sessionStorage.getItem('protoImg')
    const userNamer = window.sessionStorage.getItem('userNamer')
    // this.userNames = JSON.parse(userNamer).userName

    if (userNamer) {
      this.userNames = JSON.parse(userNamer).userName
    }
  },

  methods: {
    async chainThirdChainServerStatus() {
      console.log('chainThirdChainServerStatus')
      const {
        data,
        code
      } = await chainThirdChainServerStatus()
      if (code == 200) {
        console.log(data, '========')
        this.ids = data
      }
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      // this.$router.go(0)
      await this.$store.dispatch('user/logout')
      this.$store.commit('logoTitle/userName', '')

      this.$router.push(`/login?redirect=${this.$route.fullPath}`)

      // 清除
      sessionStorage.clear()
    },
    section() {
      this.$EventBus.$emit('section', 'true')
    },
    // 修改密码
    amendpass() {
      this.$EventBus.$emit('amendpass', 'true')
    },
    // 跳转消息页面
    massageSkip() {
      this.$EventBus.$emit('massageShow', 'true')
    },
    // 跳转坐标预设页面
    yuseh() {
      this.$EventBus.$emit('yuseh', 'true')
    },
    // 跳转子账号页面
    childs() {
      this.$EventBus.$emit('childs', 'true')
      // this.$EventBus.$emit("childs");
    },
    // 获取消息
    async getqueryRemind() {
      const token = this.$store.getters.token
      const request = await this.$axios.get('/api/remind/queryRemind', {
        headers: {
          Authorization: token
        }
      })
      const newrequest = request.data.data
      if (newrequest.length === 1) {
        return (this.massageImage = require('@/assets/Images/lingdang.png'))
      }
      if (newrequest.length !== 0) newrequest.pop()

      const ass = newrequest.find(item => {
        if (item.IS_READ === '0') {
          return true
        }
      })
      if (ass) {
        this.massageImage = require('@/assets/Images/weidu.png')
      } else {
        this.massageImage = require('@/assets/Images/lingdang.png')
      }
      // if(request.data.data.length !== 0) request.data.data.pop()
      // this.tableData = request.data.data
    }
  }
}
</script>

<style lang="scss" scoped>
  .navbar {
    height: 50px;
    background: #5a5e66;
    overflow: hidden;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

    .hamburger-container {
      line-height: 46px;
      height: 100%;
      float: left;
      cursor: pointer;
      transition: background 0.3s;
      -webkit-tap-highlight-color: transparent;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }

    .breadcrumb-container {
      float: left;
    }

    .errLog-container {
      display: inline-block;
      vertical-align: top;
    }

    .right-menu {
      float: right;
      // margin-right:100px;
      height: 100%;
      line-height: 50px;
      // background-color: aqua;
      min-width: 300px;

      &:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background 0.3s;

          &:hover {
            background: rgba(0, 0, 0, 0.025);
          }
        }
      }

      .avatar-container {
        margin-right: 30px;

        .avatar-wrapper {
          margin-top: 5px;
          position: relative;

          .user-avatar {
            cursor: pointer;
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }

          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }

  // 用户头像
  .userAvatar {
    height: 50px;
    float: left;
    width: 50px;
    overflow: hidden;
  }

  .userAvatarlingdang {
    height: 50px;
    float: left;
    width: 50px;
    overflow: hidden;
    position: relative;
  }

  .userAvatarlingdang img {
    width: 60%;
    height: 60%;
    position: absolute;
    margin: auto;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    // margin: 0 auto;
  }

  .userAvatar img {
    width: 100%;
    height: 100%;
  }

  .avatarCss {
    // background-color: aqua
    margin-top: 5px;
  }
</style>
